import { render } from "./SubRoot.vue?vue&type=template&id=0f886fb1"
import script from "./SubRoot.vue?vue&type=script&lang=js"
export * from "./SubRoot.vue?vue&type=script&lang=js"
script.render = render

export default script